import React, { useContext, useEffect } from 'react';
import { AuthContext } from '../../navigation/TemporaryUserInfo';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const Dashboard = () => {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const userData = localStorage.getItem('user');
  const userType = userData ? JSON.parse(userData).user_type : null; // 0: ivid,  1: 파트너스사

  // throo
  const renderThrooButtons = (userType: number) => {
    const buttons = [
      {
        label: '판매 현황',
        onClick: () =>
          window.open(
            'https://php-throo-stats-580098419788.asia-northeast3.run.app/stats?pass=9KmQyrwa6akVEKfP',
            '_blank',
          ),
        show: userType === 0,
      },
      {
        label: 'KPI',
        onClick: () => window.open('https://kpi.throo.kr/auth/signin', '_blank'),
        show: userType === 0,
      },
      {
        label: 'ADMIN',
        onClick: () => window.open('https://admin.throo.co.kr/', '_blank'),
        show: userType === 0,
      },
      {
        label: '스루 정산',
        onClick: () =>
          window.open(
            'https://php-throo-settlement-580098419788.asia-northeast3.run.app/',
            '_blank',
          ),
        show: userType === 0,
      },
    ];
    return buttons
      .filter((btn) => btn.show)
      .map((btn, index) => (
        <button key={index} className="btn" onClick={btn.onClick}>
          {btn.label}
        </button>
      ));
  };
  // behind
  const renderBehindButtons = (userType: number) => {
    const buttons = [
      {
        label: '판매 현황',
        onClick: () => window.open('https://api-behind.ivid.kr/api/behindstats', '_blank'),
        show: userType === 0,
      },
      {
        label: 'APK 파일 설치',
        onClick: () =>
          window.open('https://behind-sales.s3.ap-northeast-2.amazonaws.com/index.html', '_blank'),
        show: userType === 0,
      },
      {
        label: 'CEO 페이지',
        onClick: () => window.open('https://behind.ivid.kr/selfmanager/', '_blank'),
        show: userType === 0,
      },
      {
        label: '홈페이지',
        onClick: () => window.open('https://behind.ivid.kr/', '_blank'),
        show: userType === 0,
      },
    ];
    return buttons
      .filter((btn) => btn.show)
      .map((btn, index) => (
        <button key={index} className="btn" onClick={btn.onClick}>
          {btn.label}
        </button>
      ));
  };
  // knock
  const renderKnockButtons = (userType: number) => {
    const buttons = [
      {
        label: '판매 현황',
        onClick: () => (window.location.href = '/knock/sales'),
        show: userType === 0,
      },
      {
        label: '호텔 기기 관리',
        onClick: () => (window.location.href = '/knock/hotel/device'),
        show: userType === 0 || userType === 1,
      },
      {
        label: '기기 이용 현황',
        onClick: () => (window.location.href = '/knock/hotel/touchdevice'),
        show: userType === 0,
      },
      // {
      //   label: '매장 관리',
      //   onClick: () => (window.location.href = '/knock/store/status'),
      //   show: userType === 0,
      // },
      {
        label: '영업 매장 관리',
        onClick: () => (window.location.href = '/knock/partners/store/status'),
        show: userType === 0 || userType === 1,
      },

      {
        label: '판매 상세',
        onClick: () => (window.location.href = '/knock/sales/detail'),
        show: userType === 0,
      },
      {
        label: 'APK 파일 설치',
        onClick: () =>
          window.open('https://knock-sales.s3.ap-northeast-2.amazonaws.com/index.html', '_blank'),
        show: userType === 0 || userType === 1,
      },
    ];
    return buttons
      .filter((btn) => btn.show)
      .map((btn, index) => (
        <button key={index} className="btn" onClick={btn.onClick}>
          {btn.label}
        </button>
      ));
  };
  const renderKnockManagementButtons = (userType: number) => {
    const buttons = [
      {
        label: '매장/호텔 맵핑',
        onClick: () => (window.location.href = '/knock/store/mapping'),
        show: userType === 0,
      },
      {
        label: '매장/호텔 삭제',
        onClick: () => (window.location.href = '/knock/deleteStore'),
        show: userType === 0,
      },
      {
        label: '영업사 설정',
        onClick: () => (window.location.href = '/knock/partners/mapping'),
        show: userType === 0,
      },
      {
        label: '메뉴 복사',
        onClick: () => (window.location.href = '/knock/store/copyMenu'),
        show: userType === 0,
      },
      {
        label: '호텔 배달 지역 설정',
        onClick: () => (window.location.href = '/knock/hotel/address'),
        show: userType === 0,
      },
      {
        label: '고객 채팅 관리',
        onClick: () => (window.location.href = '/knock/support/chat'),
        show: userType === 0,
      },
      {
        label: '공지사항 등록하기',
        onClick: () => (window.location.href = '/knock/notice/index'),
        show: userType === 0,
      },
      {
        label: '추천 매장 관리',
        onClick: () => (window.location.href = '/knock/recommend/index'),
        show: userType === 0,
      },
      {
        label: '테스트 주문 및 쿠폰 발급',
        onClick: () => (window.location.href = '/knock/testOrder'),
        show: userType === 0,
      },
      {
        label: '마스터 관리자',
        onClick: () => (window.location.href = '/knock/navigate/master'),
        show: userType === 0,
      },
    ];
    return buttons
      .filter((btn) => btn.show)
      .map((btn, index) => (
        <button key={index} className="btn" onClick={btn.onClick}>
          {btn.label}
        </button>
      ));
  };
  const renderKnockDataButtons = (userType: number) => {
    const buttons = [
      {
        label: '매장/영업사 리포트',
        onClick: () => (window.location.href = '/knock/company/store/report'),
        show: userType === 0 || userType === 1,
      },
      {
        label: '스토어 정산',
        onClick: () => (window.location.href = '/knock/settle/store'),
        show: userType === 0,
      },
      {
        label: '호텔 정산',
        onClick: () => (window.location.href = '/knock/settle/hotel'),
        show: userType === 0,
      },
    ];
    return buttons
      .filter((btn) => btn.show)
      .map((btn, index) => (
        <button key={index} className="btn" onClick={btn.onClick}>
          {btn.label}
        </button>
      ));
  };
  const linkButtons = (userType: number, type?: string) => {
    const buttons = [
      {
        label: 'INVISIBLE IDEAS 홈페이지',
        onClick: () => (window.location.href = 'https://ivid.kr/'),
        show: userType === 0,
        type: 'ivid',
      },
      {
        label: 'THROO 홈페이지',
        onClick: () => (window.location.href = 'https://throo.co.kr/'),
        show: userType === 0,
        type: 'throo',
      },
      {
        label: 'THROO 사장님창구',
        onClick: () => (window.location.href = 'https://ceo.throo.co.kr/'),
        show: userType === 0,
        type: 'throo',
      },
      {
        label: 'BEHIND 홈페이지',
        onClick: () => (window.location.href = 'https://behind.ivid.kr/'),
        show: userType === 0,
        type: 'behind',
      },
      {
        label: 'BEHIND 관리페이지',
        onClick: () => (window.location.href = 'https://behind.ivid.kr/selfmanager/'),
        show: userType === 0,
        type: 'behind',
      },
      {
        label: 'BEHIND 경영지원 자료',
        onClick: () =>
          (window.location.href =
            'https://docs.google.com/spreadsheets/d/1UkR5u_C_5WshTvvCWF45WJ3lo8jtqRD1M43ldfvNQ6c/edit#gid=409442026'),
        show: userType === 0,
        type: 'behind',
      },
      {
        label: 'BEHIND 사업개발본부 자료',
        onClick: () =>
          (window.location.href =
            'https://docs.google.com/spreadsheets/d/1ByPnzo21qc6ziDedVAsAxqdx73m2SWEcg8QojCWBNwg/edit#gid=0'),
        show: userType === 0,
        type: 'behind',
      },
      {
        label: 'BEHIND 관리페이지 가이드',
        onClick: () =>
          (window.location.href =
            'https://invisibleideas.notion.site/0dec8ec7ac184f228900eef1fe019fa2'),
        show: userType === 0,
        type: 'behind',
      },
      {
        label: 'KNOCKKNOCK 매장 관리자 페이지',
        onClick: () => (window.location.href = 'https://knock-knock.ivid.kr/store/manager/'),
        show: userType === 0,
        type: 'knock',
      },
      {
        label: 'KNOCKKNOCK 호텔 관리자 페이지',
        onClick: () => (window.location.href = 'https://knock-knock.ivid.kr/hotel/hotelier/'),
        show: userType === 0,
        type: 'knock',
      },
      {
        label: 'KNOCKKNOCK 홈페이지',
        onClick: () => (window.location.href = 'https://knock-knock.ivid.kr'),
        show: userType === 0,
        type: 'knock',
      },
      {
        label: 'KNOCKKNOCK 사업개발본부 자료',
        onClick: () =>
          (window.location.href =
            'https://docs.google.com/spreadsheets/d/1UkR5u_C_5WshTvvCWF45WJ3lo8jtqRD1M43ldfvNQ6c/edit#gid=409442026'),
        show: userType === 0,
        type: 'knock',
      },
    ];
    return buttons
      .filter((btn) => btn.show && btn.type === type)
      .map((btn, index) => (
        <button key={index} onClick={btn.onClick}>
          <img src={`${process.env.PUBLIC_URL}/svg/ic_link.svg`} alt="링크이동" />
          <p>{btn.label}</p>
        </button>
      ));
  };

  const ThrooContent = () => {
    return (
      <div className="areaItem throo">
        <img src={`${process.env.PUBLIC_URL}/svg/throoLogo.svg`} width={'80px'} alt="스루로고" />
        <div style={{ flexWrap: 'wrap' }}>{renderThrooButtons(userType)}</div>
      </div>
    );
  };
  const BehindContent = () => {
    return (
      <div className="areaItem behind">
        <img
          src={`${process.env.PUBLIC_URL}/svg/behindLogo.svg`}
          width={'80px'}
          alt="비하인드로고"
        />
        <div style={{ flexWrap: 'wrap' }}>{renderBehindButtons(userType)}</div>
      </div>
    );
  };
  const KonckKonckContent = () => {
    return (
      <div className="areaItem knockknock">
        <img
          src={`${process.env.PUBLIC_URL}/svg/knockLogo.svg`}
          width={'80px'}
          alt="노크노크로고"
        />
        <div style={{ flexWrap: 'wrap' }}>{renderKnockButtons(userType)}</div>
      </div>
    );
  };
  const ManagerContent = () => {
    return <div className="managerWrap">{renderKnockManagementButtons(userType)}</div>;
  };
  const KnockDataContent = () => {
    return <div className="companyDataWrap">{renderKnockDataButtons(userType)}</div>;
  };
  const LinkContent = () => {
    return (
      <div className="webLinkList">
        <div>
          <div className="webLinkTitle">
            <img
              src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/ivid/ividWebLogo.png"
              alt="로고"
            />
            <p>INVISIBLE IDEAS</p>
          </div>
          <div className="linkContent">{linkButtons(userType, 'ivid')}</div>
        </div>
        <div>
          <div className="webLinkTitle">
            <img src="https://ceo.throo.co.kr/favicon-32x32.png" alt="로고" />
            <p>THROO</p>
          </div>
          <div className="linkContent">{linkButtons(userType, 'throo')}</div>
        </div>
        <div>
          <div className="webLinkTitle">
            <img
              src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/behindIcon.png"
              alt="로고"
            />
            <p>BEHIND</p>
          </div>
          <div className="linkContent">{linkButtons(userType, 'behind')}</div>
        </div>
        <div>
          <div className="webLinkTitle">
            <img
              src="https://knockknock-sales.s3.ap-northeast-2.amazonaws.com/005-web/knockknockWebLogo.png"
              alt="로고"
            />
            <p>KNOCKKNOCK</p>
          </div>
          <div className="linkContent">{linkButtons(userType, 'knock')}</div>
        </div>
      </div>
    );
  };

  return (
    <Style>
      <div className="wrapper">
        <div className="wrapperContainer">
          <div className="header flexStart">
            <h1>INVISIBLE IDEAS</h1>
            <button className="logout flexStart" onClick={() => logout()}>
              <img src={`${process.env.PUBLIC_URL}/svg/ic_logout.svg`} alt="로그아웃" />
              <p>로그아웃</p>
            </button>
          </div>
          <div className="contentWrap">
            <div className="content">
              <div className="Linkcontent">
                {renderThrooButtons(userType).length > 0 && <ThrooContent />}
                {renderBehindButtons(userType).length > 0 && <BehindContent />}
                {renderKnockButtons(userType).length > 0 && <KonckKonckContent />}
              </div>
              {renderKnockManagementButtons(userType).length > 0 && (
                <div className="settingContent">
                  <div className="title">
                    <h3>노크노크 매니저 관리페이지</h3>
                  </div>
                  <ManagerContent />
                </div>
              )}
              {renderKnockDataButtons(userType).length > 0 && (
                <div className="settingContent">
                  <div className="title">
                    <h3>노크노크 서비스 운영 통계</h3>
                  </div>
                  <KnockDataContent />
                </div>
              )}
              {linkButtons(userType, 'ivid').length > 0 && (
                <div className="webLinkWrap">
                  <div className="title">
                    <h3>관리페이지 링크</h3>
                  </div>
                  <LinkContent />
                </div>
              )}
            </div>

            <button onClick={() => navigate('/changePassword')} className="changePassword">
              <p>비밀번호 변경</p>
            </button>
          </div>
        </div>
      </div>
    </Style>
  );
};

export default Dashboard;

const Style = styled.div`
  .wrapper {
    padding: 0;
    height: 100%;
    background: #f2f5fa;
  }
  .wrapperContainer {
    height: 100vh;
    padding: 0;
    display: flex;
    overflow: hidden;
  }
  .title {
    padding-bottom: 0px;
  }

  /* header */
  .header {
    min-height: 100vh;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    padding: 20px 100px 20px 20px;
    border-radius: 0;
    background: #000000;

    h1 {
      color: #fff;
      font-size: 16px;
      font-weight: 400;
    }
    p {
      font-size: 16px;
      color: #fff;
    }
  }
  .logout {
    background: none;
    border: none;
    outline: none;

    img {
      width: 18px;
      margin-right: 6px;
    }
    p:hover {
      font-weight: 700;
    }
  }

  /* contentWrap */
  .contentWrap {
    height: 100vh;
    background: #fff;
    display: flex;
    flex-direction: column;
    flex: 1;
    margin-left: -30px;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
    overflow: auto;
    padding: 20px 40px;
  }
  .content {
    flex: 1;
  }
  .settingContent {
    margin: 10px 0;
    h3 {
      font-size: 16px;
      font-weight: 400;
    }
  }

  /* areaItem */
  .areaItem {
    width: 100%;
    margin-top: 30px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    padding: 0;
    gap: 16px;
    border-radius: 4px;

    button {
      margin-right: 10px;
      padding: 12px;
      border: none;
      outline: none;
      color: #fff;
      font-size: 16px;
      font-weight: 400;
      border-radius: 4px;
    }

    img {
      width: 60px;
    }
  }
  .behind {
    .btn {
      background: #000;
    }
  }
  .knockknock {
    .btn {
      background: #4dd2ae;
    }
  }
  .disabled {
    background: #f0f0f0 !important;
    color: #ccc !important;
    border-color: #f0f0f0 !important;
    cursor: not-allowed;
    padding: 0;
  }

  /* managerWrap */
  .managerWrap {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
    border-radius: 4px;
    button {
      margin-right: 10px;
      padding: 10px 20px;
      background: #ff9000;
      border-radius: 4px;
      border: none;
      outline: none;
      color: #fff;
      word-break: keep-all;
    }
  }
  .managerWrap button:last-of-type {
    background: #ff3c00;
  }

  /* companyDataWrap */
  .companyDataWrap {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
    border-radius: 4px;
    button {
      margin-right: 10px;
      padding: 10px 20px;
      background: #ff96b8;
      border-radius: 4px;
      border: none;
      outline: none;
      color: #fff;
      word-break: keep-all;
    }
  }
  /* webLinkWrap */
  .webLinkWrap {
    margin-top: 40px;
    button {
      padding: 0 50px 0 10px;
      margin-bottom: 16px;
      background: none;
      border: none;
      outline: none;
      display: flex;
      align-items: center;

      img {
        width: 18px;
        margin-right: 10px;
      }
      p {
        margin-top: 1px;
      }
    }
    button:hover {
      font-weight: 600;
      text-decoration: underline;
      text-underline-position: under;
    }
  }
  .webLinkList {
    margin-top: 10px;
    display: flex;
    gap: 10px;
    justify-content: stretch;
    flex-wrap: wrap;
  }
  .webLinkList > div {
    border: 1px solid #eee;
    flex: 1;
  }
  .webLinkTitle {
    display: flex;
    align-items: center;
    padding: 6px 8px;
    margin-bottom: 8px;
    background: #fafafa;

    img {
      width: 16px;
      margin-right: 6px;
    }
    p {
      font-size: 14px;
      font-weight: 600;
      padding: 0;
      margin: 0;
    }
  }
  .linkContent {
    padding: 4px 0;
    p {
      padding: 0;
      margin: 0;
      text-align: left;
      word-break: keep-all;
    }
  }

  /* 버튼*/
  .btn {
    width: 170px;
    margin-top: 4px;
    cursor: pointer;
    background: #001e62;
    position: relative;
  }
  /* 비밀번호 변경 */
  .changePassword {
    margin-top: 10px;
    background: none;
    border: none;
    outline: none;
    text-align: right;
    display: contents;

    p {
      font-size: 13px;
      font-weight: 400;
      text-decoration: underline;
      text-underline-offset: 4px;
    }
  }

  @media (max-width: 1000px) {
    .wrapperContainer {
      flex-direction: column;
    }
    .header {
      min-height: auto;
      flex-direction: row;
      padding: 0 20px;
    }
    .contentWrap {
      margin-left: 0;
      padding: 20px 3vw;
    }
    .btn {
      width: 130px;
    }
    .webLinkList {
      display: inline;
    }
    .webLinkList > div {
      margin-bottom: 10px;
    }
  }
`;
